import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();

  loggedIn = false;

  constructor(private authService: AuthService) {
    
  }
  
  ngOnInit(): void {
    this.loggedIn = this.authService.isLoggedIn();
  }

  public onSidenavClose = () => {
    this.sidenavClose.emit();
}
}
